import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mg-loader-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader-page.component.html',
  styleUrls: ['./loader-page.component.scss']
})
export class LoaderPageComponent {

}
